import PaginationFooter from "src/components/Shared/PaginationFooter";
import React, { useCallback, useEffect, useState } from "react";
import TRHeader from "src/components/Shared/Table/TRHeader";
import Table from "src/components/Shared/Table/Table";
import { connect } from "react-redux";
import { apiRequest } from "src/async/apiUtils";
import TransactionEntry from "./TransactionEntry";

const Transaction = ({ clientId, planId, setSelectedItem }) => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [transactions, setTransactions] = useState([]);
  const [meta, setMeta] = useState({});
  const [transactionLoaded, setTransactionsLoaded] = useState(false);

  const getTransactionList = useCallback(async () => {
    try {
      setTransactionsLoaded(false);

      const res = await apiRequest("get", clientId ? `/clients/:client_id/transactions` : planId ? `/plans/:plan_id/transactions` : `/transactions`, {
        queries: { limit, offset },
        params: clientId ? { client_id: clientId } : { plan_id: planId },
      });

      if (res.data.status === 200) {
        setTransactions(res.data.data || []);
        setSelectedItem((pre) => ({ ...pre, client_count: res.data.data?.filter((item) => item?.client_type === "subscription")?.length }));
        setMeta(res?.data?.meta || {});
      } else {
        setTransactions([]);
      }
    } catch (error) {
    } finally {
      setTransactionsLoaded(true);
    }
  }, [limit, offset, clientId, planId, setSelectedItem]);

  useEffect(() => {
    getTransactionList();
  }, [getTransactionList]);

  const handlePaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  return (
    <>
      <Table
        tableHeader={
          <TRHeader>
            {!planId && (
              <th
                scope="col"
                className="hidden rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:table-cell sm:pl-6">
                Plan Name
              </th>
            )}
            {!clientId && (
              <th
                scope="col"
                className="hidden rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:table-cell sm:pl-6">
                Client
              </th>
            )}
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Date
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Payment
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Status
            </th>
          </TRHeader>
        }
        colSpan="5"
        loaded={transactionLoaded}
        dataExists={transactions?.length > 0}>
        {transactions?.map((item, index) => (
          <TransactionEntry
            key={index}
            data={item}
            clientId={clientId}
            planId={planId}
          />
        ))}
      </Table>
      <PaginationFooter
        itemName="Transaction record"
        limit={limit}
        offset={offset}
        count={meta?.count}
        onChange={handlePaginationChange}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(Transaction);
